import React from "react";

interface SelectFieldProps {
  label: string;
  value: string;
  setValue: (value: string) => void;
  options: string[];
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  value,
  setValue,
  options,
}) => (
  <div>
    <label className="block  font-medium text-gray-700 mb-2">{label}</label>
    <select
      className="w-full cursor-pointer p-2 border border-gray-300 rounded-lg"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    >
      <option value="">Select {label}</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);

export default SelectField;
